import { gql } from '@apollo/client'
import { IQueryBasicData } from '../IQueryData'

export interface IRemoveAccessCardForUserData {
  removeAccessCardForUser: IQueryBasicData
}

export interface IRemoveAccessCardForUserVars {
  login: string
}

export const REMOVE_ACCESS_CARD_FOR_USER = gql`
  mutation removeAccessCardForUser($login: String!) {
    removeAccessCardForUser(login: $login) {
      status
      error
      code
      message
    }
  }
`
